import { useTranslation } from 'react-i18next';
import * as z from 'zod';
import { ProgressLayout } from '../../../components/layouts/progress-layout';
import { PatchInviteForm } from '../../../components/patch-invite-form';
import { Input } from '../../../components/ui/input';
import { PHONE_NUMBER_REGEX } from '../../../constants/misc';

export const schema = z.object({
  email: z.string().email(),
  mobileNumber: z.string().trim().regex(PHONE_NUMBER_REGEX),
  phoneNumber: z.union([z.string().trim().regex(PHONE_NUMBER_REGEX), z.literal('')]),
});

function extractDefaults({ patient }, invite) {
  return {
    email: patient?.email ?? invite.patient.email ?? '',
    mobileNumber: patient?.mobileNumber ?? invite.patient.mobileNumber ?? '',
    phoneNumber: patient?.phoneNumber ?? invite.patient.phoneNumber ?? '',
  };
}

function transformValues({ email, mobileNumber, phoneNumber }) {
  return {
    patient: { email, mobileNumber, phoneNumber },
  };
}

export function ContactDetails(props) {
  const { t } = useTranslation('page.details');

  return (
    <PatchInviteForm
      extractDefaults={extractDefaults}
      transformValues={transformValues}
      schema={schema}
      nextPath={props.next.path}
    >
      <ProgressLayout {...props}>
        <h1 className="title">{t('contact-details.title')}</h1>
        <p className="mb-5">{t('contact-details.text')}</p>
        <div className="space-y-5">
          <Input type="email" name="email" label={t(`contact-details.email`)} />
          <Input name="mobileNumber" type="tel" label={t(`contact-details.mobilePhone`)} />
          <Input name="phoneNumber" type="tel" label={t(`contact-details.otherPhone`)} optional />
        </div>
      </ProgressLayout>
    </PatchInviteForm>
  );
}
